import { render, staticRenderFns } from "./WeeklyChartWidget.vue?vue&type=template&id=50d54d0a&scoped=true&"
import script from "./WeeklyChartWidget.vue?vue&type=script&lang=ts&"
export * from "./WeeklyChartWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d54d0a",
  null
  
)

export default component.exports